/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wise_Pale_Bull_NoteInputs */

const en_wise_pale_bull_note = /** @type {(inputs: Wise_Pale_Bull_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Translate`)
};

const de_wise_pale_bull_note = /** @type {(inputs: Wise_Pale_Bull_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersetzen`)
};

/**
* | output |
* | --- |
* | "Translate" |
*
* @param {Wise_Pale_Bull_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wise_pale_bull_note = /** @type {((inputs?: Wise_Pale_Bull_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wise_Pale_Bull_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wise_pale_bull_note(inputs)
	return de_wise_pale_bull_note(inputs)
});